import { render, staticRenderFns } from "./CreateEmployee.vue?vue&type=template&id=3629a9d0&scoped=true&"
import script from "./CreateEmployee.vue?vue&type=script&lang=js&"
export * from "./CreateEmployee.vue?vue&type=script&lang=js&"
import style0 from "./CreateEmployee.vue?vue&type=style&index=0&id=3629a9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629a9d0",
  null
  
)

export default component.exports